module.exports = __webpack_public_path__ + "media/images/icon_notice-6f298cca57a5a8b36055fd638fa31481.png";